


















































import Vue from 'vue';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins/index';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { MemberProvidersResponseModel } from '@/@types/member';
import DataTableSync from 'datatablesync/src/DataTableSync.class';
import { isNil } from 'lodash';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  refreshError: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'RemoveProvider',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      refreshError: false,
    };
  },
  computed: {
    dataTableSync(): DataTableSync {
      return this.$store.getters.currentDataTableSyncInstance(
        this.params.dataTableRef,
      );
    },
    providers(): MemberProvidersResponseModel[] {
      return this.$store.getters.providers;
    },
    currentProvider(): MemberProvidersResponseModel {
      const providerIndex = this.providers.findIndex((provider) => {
        return provider.providerId.toString() === this.params.providerId.toString();
      });
      return providerIndex > -1 ? this.providers[providerIndex] : null;
    },
  },
  methods: {
    removeProvider(): void {
      this.isLoading = true;
      this.$store
        .dispatch('deleteProvider', this.currentProvider.providerId)
        .then(() => {
          this.refreshProviders();
        })
        .catch(() => {
          this.showErrorMessage = !this.showErrorMessage;
          this.isLoading = false;
        });
    },
    async refreshProviders(): Promise<void> {
      try {
        if (!isNil(this.dataTableSync)) {
          await this.dataTableSync.refresh();
        } else {
          await this.$store.dispatch('getProviders');
        }
        // @ts-ignore
        this.confirmBeforeClose = false;
        this.showSuccessMessage = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.triggerRefreshError({
          message: [
            'remove-provider_text_refresh-data-error-message',
            'global_connection-error',
          ],
        });
      }
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
